import * as React from 'react';
import {WithStyles, withStyles,} from '@material-ui/core';
import TranslateNew from '@translate/TranslateNew';
import { EditActionStyle } from './EditAction.style';
import SCHOOL_TYPES from '@constants/schoolTypes';

const tn: TranslateNew = TranslateNew.getInstance();

interface IState {
  test:number;
}

interface IProps extends WithStyles<typeof EditActionStyle> {
  occurences:number;

  title:string;

  atSchool:boolean;
  school:SCHOOL_TYPES|undefined;
  schoolAge:number;
  loc:string;
  hour:number;
  minute:number;


  transparent?:boolean;
  // time used when the handover is moved away from school
  defaultHour?:number;
  error?:string;

  update : (atSchool:boolean, loc:string, hour:number, minute:number, direct:boolean) => void;
}

class ChangeTimePlaceDay extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);
    
    this.state = {
      test:0
    };

  }


  public render() {
    const {classes, title,occurences, atSchool,loc,hour,minute} = this.props;

    return (<>
      <div className={classes.handoverDay} style={this.props.transparent?{backgroundColor:'transparent'}:{}}>
        <div className={classes.handoverTitleRow}>
          <div className={classes.handoverDayTitle}>
            {title}
          </div>
          <div className={classes.handoverDayOccurences}>
            {tn.lang.calOccurences(occurences)}
          </div>
        </div>
        <div>
          <label className={classes.checkboxLabel}>
            <input type="checkbox" checked={atSchool} className={classes.checkbox}
              onChange={(event) => this.props.update(!atSchool, "",
                (atSchool && this.props.defaultHour !== undefined) ? this.props.defaultHour : 12, 0, true)} />
              {tn.lang.calHandoverAtSchool(this.props.school, this.props.schoolAge)}
          </label>
        </div>
        <div className={classes.textInputLine} style={{maxHeight: atSchool?"0px":"60px", overflow: 'hidden', transition: '0.3s'}}>
          <select name="hour" value={hour} disabled={atSchool} className={classes.textInput}
            onChange={(event) => this.props.update(atSchool, loc, Number.parseInt(event.target.value,10), minute, true)}>
            <option value="0">00</option>
            <option value="1">01</option>
            <option value="2">02</option>
            <option value="3">03</option>
            <option value="4">04</option>
            <option value="5">05</option>
            <option value="6">06</option>
            <option value="7">07</option>
            <option value="8">08</option>
            <option value="9">09</option>
            <option value="10">10</option>
            <option value="11">11</option>
            <option value="12">12</option>
            <option value="13">13</option>
            <option value="14">14</option>
            <option value="15">15</option>
            <option value="16">16</option>
            <option value="17">17</option>
            <option value="18">18</option>
            <option value="19">19</option>
            <option value="20">20</option>
            <option value="21">21</option>
            <option value="22">22</option>
            <option value="23">23</option>
          </select>:
          <select name="minute" value={minute} disabled={atSchool} className={classes.textInput}
            onChange={(event) => this.props.update(atSchool, loc, hour, Number.parseInt(event.target.value,10), true)}>
            <option value="0">00</option>
            <option value="5">05</option>
            <option value="10">10</option>
            <option value="15">15</option>
            <option value="20">20</option>
            <option value="25">25</option>
            <option value="30">30</option>
            <option value="35">35</option>
            <option value="40">40</option>
            <option value="45">45</option>
            <option value="50">50</option>
            <option value="55">55</option>
          </select>
          <input
            disabled={atSchool}
            type="text"
            value={loc}
            onChange={(event) => this.props.update(atSchool, event.target.value, hour, minute, false)}
            autoCorrect="on"
            spellCheck={true}
            autoComplete="off"
            maxLength={30}
            className={classes.textInput+" "+classes.locationInput}
            placeholder={tn.lang.handoverLocationLabel}
          />
        </div>
        {this.props.error ? <div className={classes.errorText}>{this.props.error}</div> : null}
      </div>
      </>
    );
  }
}

export default withStyles(EditActionStyle)(ChangeTimePlaceDay);



// WEBPACK FOOTER //
// ./src/components/calendar2/editPane/editActions/ChangeTimePlaceDay.tsx